module.exports = __webpack_public_path__ + "static/media/1027959.69464681.png";